import { companiesSlice } from '@pn/core/storage/company/companiesSlice';
import { companyDocumentsSlice } from '@pn/core/storage/intel/companyDocumentsSlice';
import { companyExtraInfoSlice } from '@pn/core/storage/intel/companyExtraInfoSlice';
import {
  companyMonthlyStatsSlice,
  companyQuarterlyCorporateStatsSlice,
} from '@pn/core/storage/intel/companyStatsSlice';
import { realTimeStockSlice } from '@pn/core/storage/intel/realTimeStockSlice';
import { createReduxStore } from '@pn/services/redux/store';
import { isNil } from 'lodash-es';
import { formationsSlice } from 'src/application/storage/formations/formationsSlice';
import { companyKPIsSlice } from 'src/application/storage/kpi/companyKPIsSlice';
import { mergersAndAcquisitionsSlice } from 'src/application/storage/mergers-and-acquisitions/mergersAndAcquisitionsSlice';
import { companiesOverviewSlice } from './companies-overview/companiesOverviewSlice';
import { formationsOverviewSlice } from './formations/formationsOverviewSlice';
import { formationsStatsSlice } from './formations/formationsStatsSlice';
import { intelWorkspaceItemsSlice } from './intel-query/intelWorkspaceItemsSlice';
import { intelUiSlice } from './intel-ui/intelUiSlice';
import { intelReportsSlice } from './report/intelReportsSlice';

export const store = createReduxStore({
  [formationsSlice.name]: formationsSlice.reducer,
  [intelWorkspaceItemsSlice.name]: intelWorkspaceItemsSlice.reducer,
  [companyKPIsSlice.name]: companyKPIsSlice.reducer,
  [mergersAndAcquisitionsSlice.name]: mergersAndAcquisitionsSlice.reducer,
  [intelReportsSlice.name]: intelReportsSlice.reducer,
  [intelUiSlice.name]: intelUiSlice.reducer,

  /* Core */
  [companiesSlice.name]: companiesSlice.reducer,
  [companyDocumentsSlice.name]: companyDocumentsSlice.reducer,
  [companyExtraInfoSlice.name]: companyExtraInfoSlice.reducer,
  [companyQuarterlyCorporateStatsSlice.name]:
    companyQuarterlyCorporateStatsSlice.reducer,
  [companyMonthlyStatsSlice.name]: companyMonthlyStatsSlice.reducer,
  [realTimeStockSlice.name]: realTimeStockSlice.reducer,
  [companiesOverviewSlice.name]: companiesOverviewSlice.reducer,
  [formationsOverviewSlice.name]: formationsOverviewSlice.reducer,
  [formationsStatsSlice.name]: formationsStatsSlice.reducer,
});

// NOTE: Do not delete/rename because the Stack Intel Email Sender data job relies on calling this function
declare global {
  interface Window {
    isLoggedIn: () => boolean;
  }
}

window.isLoggedIn = () => {
  const state = store.getState();
  const isLoggedIn = !isNil(state.currentUser?.user);
  return isLoggedIn;
};
